// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

const root = ReactDOM.createRoot(document.getElementById('root'));
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const paypalClientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;
const paypalOptions = {
  "client-id": paypalClientId,
  "currency": "EUR",
  "intent": "capture"
};

if (!googleClientId) {
  console.error("CRITICAL ERROR: REACT_APP_GOOGLE_CLIENT_ID is not defined in the build environment!");
}

root.render(
  <>
    {googleClientId ? (
      <GoogleOAuthProvider clientId={googleClientId}>
        <PayPalScriptProvider options={paypalOptions}>
          <App />
        </PayPalScriptProvider>
      </GoogleOAuthProvider>
    ) : (
      <div style={{ padding: '20px', textAlign: 'center', color: 'red', backgroundColor: 'white', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <h1>Application Configuration Error</h1>
        <p>The Google Client ID (REACT_APP_GOOGLE_CLIENT_ID) is missing or was not provided during the application build process.</p>
        <p>Please ensure this environment variable is correctly set in the CI/CD pipeline.</p>
      </div>
    )}
  </>
);

reportWebVitals();
